import React, { useState } from 'react';
import PremiumBadge from './PremiumBadge';

function SqlPreview({ sql }) {
  return (
    <div style={{ borderTop: '1px solid #1e2130' }}>
      <div className="flex items-center justify-between px-4 py-2" style={{ backgroundColor: '#08090d' }}>
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#1e2130' }} />
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#1e2130' }} />
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#1e2130' }} />
          <span className="text-xs font-mono ml-1" style={{ color: '#374151' }}>sql</span>
        </div>
        <span className="text-xs font-mono" style={{ color: '#374151' }}>{sql.split('\n').length} lines</span>
      </div>
      <pre style={{
        margin: 0, padding: '14px 20px',
        fontFamily: "'Courier New', Courier, monospace",
        fontSize: '12.5px', color: '#86efac', lineHeight: 1.75,
        backgroundColor: '#08090d', overflowX: 'auto', whiteSpace: 'pre',
      }}>
        {sql}
      </pre>
    </div>
  );
}

export default function BiQueryRow({ query }) {
  const [open, setOpen] = useState(false);
  const [cursor, setCursor] = useState(null);
  const canExpand = !query.isPremium;

  return (
    <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #1e2130', backgroundColor: '#0f1117', position: 'relative' }}>
      <button
        type="button"
        className="w-full flex items-center gap-3 px-4 py-3 text-left"
        style={{ background: 'none', border: 'none', cursor: canExpand ? 'pointer' : 'default' }}
        onClick={() => canExpand && setOpen(o => !o)}
        onMouseMove={e => !canExpand && setCursor({ x: e.clientX, y: e.clientY })}
        onMouseLeave={() => setCursor(null)}
      >
        <svg
          className="w-3.5 h-3.5 flex-shrink-0 transition-transform duration-200"
          style={{ color: canExpand ? '#4b5563' : '#1e2130', transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}
          fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        <span className="font-mono text-sm font-medium flex-1 text-left truncate"
          style={{ color: canExpand ? '#c9ccd6' : '#4b5563' }}>
          {query.queryName}
        </span>
        <div className="flex items-center gap-2 flex-shrink-0">
          {query.isPremium && <PremiumBadge />}
        </div>
      </button>

      {cursor && (
        <div
          className="fixed text-xs px-2.5 py-1.5 rounded-lg pointer-events-none"
          style={{
            top: cursor.y + 14, left: cursor.x + 12,
            backgroundColor: '#1e2130', color: '#9ca3af',
            border: '1px solid #2d3148', whiteSpace: 'nowrap', zIndex: 50,
          }}
        >
          Premium query — SQL restricted
        </div>
      )}

      {open && <SqlPreview sql={query.sql} />}
    </div>
  );
}
